/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "client": {
        "nested": {
          "kds": {
            "nested": {
              "models": {
                "nested": {
                  "KdsStation": {
                    "fields": {
                      "name": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "id": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "role": {
                        "type": "squareup.client.kds.models.KdsStation.Role",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Role": {
                        "values": {
                          "PREP": 1,
                          "EXPEDITE": 2,
                          "IN_FLIGHT": 3
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.client?.nested?.kds?.nested?.models?.nested?.KdsStation && !$root.nested?.squareup?.nested?.client?.nested?.kds?.nested?.models?.nested?.KdsStation?.nested?.Role) {
  $root.addJSON(jsonData);
}

/**
 * Represents a specific class of KDS configured by a merchant.
 *
 * SOURCE KdsStation @ squareup/client/kds/models/models.proto at 13:1
 */
export const KdsStation = $root.lookupType('squareup.client.kds.models.KdsStation');
fixType(KdsStation);
Builder.createAndAttachToType(KdsStation);
/**
 * Defines the different classifications of KDS's. Each entry in this enum
 * will have different interaction, display rules, UI variations, etc.
 *
 * SOURCE Role @ squareup/client/kds/models/models.proto at 29:3
 */
KdsStation.Role = $root.lookupEnum('squareup.client.kds.models.KdsStation.Role').values;